import axios from 'axios'

const ROUTE = '/rest/v4/products';

export default {
  loadData(id) {
    return axios.get(`${ROUTE}/${id}`);
  },

  loadProducts(params) {
    return axios.get(`${ROUTE}`, params);
  },

  loadCategoryInformation(id) {
    return axios.get(`${ROUTE}/${id}/categoryinformation`);
  },

  loadActiveUnits(id) {
    return axios.get(`${ROUTE}/${id}/activeunits`);
  },

  post(data, generateMatchCode=false) {
    return axios.post(`${ROUTE}?generateMatchCode=${generateMatchCode}`, data);
  },

  update(id, data, generateMatchCode=false) {
    return axios.put(`${ROUTE}/${id}?generateMatchCode=${generateMatchCode}`, data);
  },

  async getLinkedProductPartsListsWithFlatPrice(id) {
    return axios.get(`${ROUTE}/${id}/linkedproductpartslistwithflatprice`);
  },

  loadStorageInformation(id) {
    return axios.get(`${ROUTE}/${id}/storageinformation`);
  },

  loadStorageInformationWithExcludedStorageOrganizationTypes(id, getParams) {
    return axios.get(`${ROUTE}/${id}/storageinformation`, { params: getParams} );
  },

  getReplenishmentRules(id){
    return axios.get(`${ROUTE}/${id}/replenishments`);
  },

  getProductAttributeValues(id, attribute) {
    return axios.get(`${ROUTE}/${id}/attributes/${attribute}/values`);
  },

  loadPriceConditions(data) {
    return axios.post(`${ROUTE}/priceconditionrequest`, data);
  },

  loadRecommendedSupplier(id, params) {
    return axios.get(`${ROUTE}/${id}/recommendedSupplier`, { params: params });
  },

  cloneCategories(id, data) {
    return axios.post(`${ROUTE}/${id}/copycategories`, data);
  },

  getStandardPrice(data) {
    return axios.post(`${ROUTE}/standardpricerequest`, data);
  }
};
